import React, { useCallback } from 'react'
import { ListItemIcon, MenuItem } from '@mui/material';
import { CompanyMenuItemProps } from './CompanyMenuItem.props'

const CompanyMenuItem = ({
  handleDropDown,
  option,
  subMenuItem,
}: CompanyMenuItemProps) => {
  const handleClick = useCallback(() => {
    handleDropDown(option, subMenuItem)
  }, [handleDropDown, option, subMenuItem])

  const Icon = option.icon;

  return (
    <MenuItem
      key={option.id}
      id={`company-dropdown-item-${option.id}`}
      onClick={handleClick}
    >
      {Icon && (
        <ListItemIcon sx={{ minWidth: 36, color: 'primary.main' }}>
          <Icon fontSize="small" color="inherit" />
        </ListItemIcon>
      )}
      {option.title}
    </MenuItem>
  )
}

export default CompanyMenuItem
